import { buildMakeUseAxios } from "@api";
import { useCallback } from "react";

const axios = buildMakeUseAxios(`${import.meta.env.VITE_WORKSHOP_SERVICE_URL}/v2`);

/**
 * @deprecated
 */
export const useGetSupportCourse = () => {
  const [state, execute, cancel] = axios(
    {
      url: "/supportCourses",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (supportCourseId) => {
      return execute({
        url: `/supportCourses/${supportCourseId}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useCreateSupportCourse = () => {
  const [state, execute, cancel] = axios(
    {
      url: "/supportCourses",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data) => {
      return execute({
        url: "/supportCourses",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useAddSupportCourseSession = () => {
  const [state, execute, cancel] = axios(
    {
      url: "/supportCourses",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (supportCourseId, data) => {
      return execute({
        url: `/supportCourses/${supportCourseId}/session`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useCloseSupportCourse = () => {
  const [state, execute, cancel] = axios(
    {
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (supportCourseId: string) => {
      return execute({ url: `/supportCourses/${supportCourseId}/close` });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useDeleteSupportCourse = () => {
  const [state, execute, cancel] = axios(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (supportCourseId: string) => {
      return execute({ url: `/supportCourses/${supportCourseId}` });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export * from "./getSupportCourse";
export * from "./getSupportCourseDashboard";
export * from "./patchSupportCourse";
export * from "./addWorkshopsParticipants";
